/**
 * Light chat — a per-phone choice in Settings → You → This phone (TKT-1619).
 *
 * On the Liquid Glass look the full-screen conversation, the minimised chat
 * pill and the live-call bar are dark glass by default. Switching this on
 * draws them light instead. It is this phone's, not the account's, so it lives
 * in this device's storage like haptics and the maps app.
 *
 * The choice is shown as `data-chat-theme="light"` on <html>, which the glass
 * rules in globals.css read; the native composer is told separately, through
 * the bar's `onDark` (MobileNav), because it is drawn above the WebView.
 *
 * No "use client": MobileNav and the This phone screen both import it (#18).
 */

const KEY = 'mucka_chat_light';
export const CHAT_THEME_EVENT = 'mucka-chat-theme';

export function isChatLight(): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
}

/** Puts this phone's choice on <html>, where the glass rules read it. */
export function applyChatTheme(light: boolean = isChatLight()): void {
  if (typeof document === 'undefined') return;
  if (light) document.documentElement.setAttribute('data-chat-theme', 'light');
  else document.documentElement.removeAttribute('data-chat-theme');
}

export function setChatLight(light: boolean): void {
  try {
    if (light) localStorage.setItem(KEY, 'true');
    else localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable: it still applies until the app is closed */
  }
  applyChatTheme(light);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHAT_THEME_EVENT, { detail: { light } }));
  }
}
